import { apiClient } from "./apiclient";

// GET /api/notifications/{userId}
export const getNotifications = (userId, token) =>
  apiClient.get(`/api/notifications/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// PUT /api/notifications/{userId}/read   body: ["id1","id2"]
export const markNotificationsRead = (userId, ids, token) =>
  apiClient.put(`/api/notifications/${userId}/read`, ids, {
    headers: { Authorization: `Bearer ${token}` },
  });
